import { DelayText } from "features/CenterContent/VehicleDetails/TrainDetails/TrainRoute/TrainStop/styles";
import { getTrainSemantic } from "features/CenterContent/VehicleDetails/TrainDetails/TrainRoute/TrainStop/utils";
import { FC } from "react";
import { HStack, Text, VStack } from "shared/components/Spor";
import { useThemeSemantic } from "shared/theme/themeSemantic";
import { formatTimeString } from "shared/utils/dateTimeUtils";

type TrainTimeProps = {
  scheduledTime: Date | null;
  actualTime: Date | null;
  estimatedTime: Date | null;
  delay: number;
};

export const TrainTime: FC<TrainTimeProps> = ({
  scheduledTime,
  actualTime,
  estimatedTime,
  delay,
}) => {
  const isDisabled = !actualTime;
  const delaySemantics = getTrainSemantic({ delay }) ?? "neutral";
  const theme = useThemeSemantic(delaySemantics);
  const delayColor = isDisabled ? theme.colorTextDisabled : theme.colorSemantic;
  const delayText = (delay > 0 ? "+" : "–") + Math.abs(delay);

  return (
    <VStack flex={1} gap={0} alignItems="flex-start">
      <DelayText
        variant="sm"
        textDecoration={
          actualTime || estimatedTime ? "line-through" : undefined
        }
      >
        {formatTimeString(scheduledTime)}
      </DelayText>

      <HStack position="relative" gap="6px" alignItems="center">
        <Text
          variant="sm"
          color={isDisabled ? theme.colorTextDisabled : undefined}
        >
          {formatTimeString(actualTime ?? estimatedTime ?? scheduledTime)}
        </Text>

        {delay !== 0 && (
          <>
            <Text variant="sm" color={theme.colorTextDisabled}>
              |
            </Text>
            <Text
              variant="sm"
              style={{ fontSize: "14px", lineHeight: 0 }}
              color={delayColor}
              fontWeight={600}
            >
              {delayText}
            </Text>
          </>
        )}
      </HStack>
    </VStack>
  );
};
